import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "mdiSvg",
    },
    theme: {
        themes: {
            light: {
                primary: "#09586e",
            },
            dark: {
                primary: "#5fcae8",
                secondary: "#737373",
            },
        },
        options: { customProperties: true },
    },
});
